// extracted by mini-css-extract-plugin
export default {"dataBlock":"GuestColumn_dataBlock__-Lv3n","title":"GuestColumn_title__B7sjI","titleBlock":"GuestColumn_titleBlock__UmBqm","empty":"GuestColumn_empty__tY+n2"};